<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'

import { useSessionStore } from './session-store'
import AppHeader from './shell/AppHeader.vue'
import AppSidebar from './shell/AppSidebar.vue'
import BrandBar from './shell/BrandBar.vue'
import EngineBar from './shell/EngineBar.vue'

const route = useRoute()
const { status } = storeToRefs(useSessionStore())

// Public pages (signed out, launch refused) show only the brand bar, even when a session
// cookie is still around: they are about not being signed in.
const showShell = computed(() => status.value === 'signed-in' && route.meta.public !== true)
const showEngineBar = computed(() => showShell.value && !route.meta.hideEngineSelector)
</script>

<template>
  <a href="#main" class="skip-link" data-testid="app-skip-link">Skip to content</a>
  <!-- As in the prototype, the header and sidebar stay put and the page column scrolls. -->
  <div v-if="showShell" class="flex h-dvh flex-col bg-canvas" data-testid="app-shell">
    <AppHeader />
    <div class="flex min-h-0 flex-1 max-[900px]:flex-col">
      <AppSidebar />
      <div class="flex min-w-0 flex-1 flex-col overflow-auto bg-surface">
        <EngineBar v-if="showEngineBar" />
        <main id="main" tabindex="-1" class="min-w-0 flex-1 p-6">
          <RouterView />
        </main>
      </div>
    </div>
  </div>
  <template v-else>
    <BrandBar />
    <main id="main" tabindex="-1" class="mx-auto w-full max-w-5xl px-4 py-6">
      <p
        v-if="status === 'unavailable'"
        role="alert"
        class="text-danger"
        data-testid="app-unavailable-error"
      >
        revUP couldn't load. Reload the page, or open revUP again from foreUP.
      </p>
      <RouterView v-else />
    </main>
  </template>
</template>
